module.exports = __webpack_public_path__ + "807bc928bbe29436226846dd227c6774.png";